import { GridProps } from "@material-ui/core";
import styled from "styled-components";
import { Button } from "../../../../components/button";
import { Checkbox } from "../../../../components/forms/checkbox";
import { Widget } from "../../../../components/widget";
import { StatusEnum } from "../../../../store/users/models/internal";
import { colours } from "../../../../styles/colours";

export const StyledWidget = styled(Widget)`
  &:not(:last-child) {
    margin-bottom: 1em;
  }
`;

export const ServiceDetail = styled.div<
  {
    status: Exclude<StatusEnum, "DELETED" | "NA">;
    changed?: boolean;
  } & GridProps
>`
  border: 1px solid ${colours.lightGrey};
  border-radius: 6px;
  padding: 1em;
  width: 100%;
  background: ${({ status, changed }) => {
    if (changed) {
      return '#f4e66a';
    }
    switch (status) {
      case "VERIFIED":
        return "#bee3b6";
      case "DECLINED":
      case "FAILED":
        return "#ff9d9d";
      default:
        return colours.lightGrey;
    }
  }};

  &:not(:last-child) {
    margin-bottom: 1em;
  }

  .MuiChip-label {
    white-space: normal;
  }
`;

export const ChipContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  & > * {
    margin: 0.5em;
    font-weight: 500;
    background: #f9f9f94f;
  }
`;

export const StyledCheckbox = styled(Checkbox)`
  padding: 0;
`;

export const Label = styled.span`
  font-weight: 500;
`;

export const StyledButton = styled(Button)`
  & + & {
    margin-left: 1em;
  }
`;
